import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import type { ReactNode } from 'react';

import { FontAwesomeScalableIcon } from '@mend/mui';
import { Box, Card, Stack, Typography } from '@mui/material';

const asideWidth = '260px';

export function Root(props: { children: ReactNode }) {
  return (
    <Card
      variant="outlined"
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto' },
        alignItems: 'stretch',
        gap: 3,
        padding: 3,
        mb: 2,
        bgcolor: 'background.default',
        backgroundImage: 'none',
      }}
    >
      {props.children}
    </Card>
  );
}

export function Main(props: { children: ReactNode }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 2,
        minWidth: 0,
      }}
    >
      {props.children}
    </Box>
  );
}

export function Eyebrow(props: { icon: IconDefinition; color: string; children: ReactNode }) {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ color: props.color }}>
      <FontAwesomeScalableIcon icon={props.icon} fontSize="small" color="inherit" />
      <Typography component="p" variant="caption" color="inherit" textTransform="uppercase">
        {props.children}
      </Typography>
    </Stack>
  );
}

export function Title(props: { children: ReactNode }) {
  return (
    <Typography component="p" variant="h5">
      {props.children}
    </Typography>
  );
}

export function Copy(props: { children: ReactNode }) {
  return <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>{props.children}</Box>;
}

export function Aside(props: { children: ReactNode }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        alignSelf: 'stretch',
        width: { xs: '100%', md: asideWidth },
        borderTop: (theme) => ({ xs: `1px solid ${theme.palette.divider}`, md: 0 }),
        borderLeft: (theme) => ({ xs: 0, md: `1px solid ${theme.palette.divider}` }),
        pt: { xs: 3, md: 0 },
        pl: { xs: 0, md: 3 },
      }}
    >
      {props.children}
    </Box>
  );
}
